import { Info, Mic } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { useNavigate, useSearchParams } from "react-router-dom";
import SelectAudioDevice from "sections/audio-check/select-audio-device";
import MicTest from "sections/audio-check/mic-test";

const OnboardingAudioCheck = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const planParam = searchParams.get("plan");

  const handleLetsGo = () => {
    if (planParam) {
      navigate(`/subscription?plan=${planParam}`);
    } else {
      navigate("/create-notes", { state: { showDemo: true } });
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-brand-off-white overflow-y-auto flex items-start justify-center p-6 font-dm-sans">
      <Helmet>
        <title>Audio Setup · NirvaScribe</title>
      </Helmet>

      <div className="w-full max-w-[440px] bg-white rounded-xl shadow-auth-card p-6 md:p-7 my-auto">

        {/* Logo */}
        <div className="mb-5">
          <img src="/logo-name.png" alt="NirvaScribe" className="h-7 md:h-8" />
        </div>

        {/* Header */}
        <div className="flex items-center gap-3 mb-5">
          <div className="w-9 h-9 rounded-full bg-primary flex items-center justify-center shrink-0">
            <Mic size={16} strokeWidth={2} className="text-gray-800" />
          </div>
          <div>
            <h2 className="text-base font-semibold text-gray-900 leading-tight">
              Audio Setup
            </h2>
            <p className="text-xs text-gray-400 mt-0.5">
              Quick check before your first session
            </p>
          </div>
        </div>

        {/* Browser permission note */}
        <div className="flex items-start gap-2 bg-blue-50 border border-blue-100 rounded-lg px-3 py-2.5 mb-5">
          <Info size={14} className="text-blue-500 mt-0.5 shrink-0" />
          <p className="text-[12px] text-blue-700 leading-snug">
            Your browser will ask to access your microphone — click{" "}
            <strong>Allow</strong>. On Safari or Edge, you may also need to enable
            it under browser settings.
          </p>
        </div>

        {/* Section 1 — Devices */}
        <div className="mb-5">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-5 h-5 rounded-full bg-gray-900 text-white text-[10px] font-bold flex items-center justify-center shrink-0">
              1
            </span>
            <h3 className="text-sm font-semibold text-gray-800">
              Select your audio devices
            </h3>
          </div>
          <SelectAudioDevice compact />
        </div>

        <div className="border-t border-gray-100 mb-5" />

        {/* Section 2 — Mic test */}
        <div className="mb-7">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-5 h-5 rounded-full bg-gray-900 text-white text-[10px] font-bold flex items-center justify-center shrink-0">
              2
            </span>
            <h3 className="text-sm font-semibold text-gray-800">
              Test your microphone
            </h3>
          </div>
          <MicTest />
        </div>

        {/* CTA */}
        <button
          type="button"
          onClick={handleLetsGo}
          className="w-full h-[46px] rounded-[10px] bg-gradient-to-r from-pink-500 to-purple-600 text-white text-[15px] font-bold hover:from-pink-600 hover:to-purple-700 hover:-translate-y-px transition-all duration-200 shadow-sm"
        >
          Let's Go →
        </button>
      </div>
    </div>
  );
};

export default OnboardingAudioCheck;
